export class Controller {

    constructor() {

    }
 
    $onInit() {
    }

    $onChanges() {
    }
}



// WEBPACK FOOTER //
// ./src/portal/components/sp-license-info/sp-license-info.controller.js